import { render, staticRenderFns } from "./version-info.vue?vue&type=template&id=3f760d6a&scoped=true&"
import script from "./version-info.vue?vue&type=script&lang=js&"
export * from "./version-info.vue?vue&type=script&lang=js&"
import style0 from "./version-info.vue?vue&type=style&index=0&id=3f760d6a&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f760d6a",
  null
  
)

export default component.exports